<template>
    <v-card>
        <v-card-title>
            <v-toolbar dense flat color="white">
                <v-toolbar-title>Elenco Prodotti e Servizi</v-toolbar-title>
                <v-divider
                        class="mx-2"
                        inset
                        vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="createProduct">Nuovo</v-btn>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Cerca..."
                        single-line
                        hide-details
                ></v-text-field>
            </v-toolbar>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="products"
                :loading="loading"
                class="elevation-1"
                select-all
                v-model="selected"
                item-key="Id"
                :search="search"
                :pagination.sync="pagination"
        >
            <template slot="items" slot-scope="props">
                <td>
                    <v-checkbox
                            v-model="props.selected"
                            primary
                            hide-details
                    ></v-checkbox>
                </td>
                <td>{{ props.item.Description }}</td>
                <td>{{ props.item.TypeCode }}</td>
                <td>{{ props.item.ArticleCode }}</td>
                <td>{{ props.item.UnitOfMeasure }}</td>
                <td>{{ decodeVatType(props.item.VatTypeId) }}</td>
                <td class="text-xs-right">{{ $n(props.item.UnitPrice, 'currencyPrecision5') }}</td>
                <td class="justify-center layout px-0">
                    <v-toolbar-items>
                        <v-tooltip bottom>
                            <v-btn slot="activator" icon
                                   small
                                   class="mr-2"
                                   @click="duplicate(props.item)"
                            >
                                <v-icon small>fa-copy</v-icon>
                            </v-btn>
                            <span>Duplica</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <v-btn slot="activator" icon
                                   small
                                   class="mr-2"
                                   @click="editItem(props.item)"
                            >
                                <v-icon small>edit</v-icon>
                            </v-btn>
                            <span>Modifica</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <v-btn slot="activator" icon
                                   small
                                   class="mr-2"
                                   @click="showDeleteItemDialog(props.item)"
                            >
                                <v-icon small>delete</v-icon>
                            </v-btn>
                            <span>Elimina</span>
                        </v-tooltip>
                    </v-toolbar-items>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                La tua ricerca: "{{ search }}" non ha restituito risultati.
            </v-alert>
        </v-data-table>

        <div class="text-xs-center">
            <v-dialog
                    v-model="deleteDialog"
                    width="500"
            >
                <v-card>
                    <v-card-title
                            class="headline grey lighten-2"
                            primary-title
                    >
                        Elimina Prodotto
                    </v-card-title>

                    <v-card-text>
                        Attenzione: una volta eliminato, un prodotto non è più recuperabile.
                        <br>
                        Continuare?
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-btn
                                color="default"
                                flat
                                @click="deleteDialog = false"
                        >
                            Annulla
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                flat
                                @click="deleteItem(itemToDelete)"
                        >
                            Elimina
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </v-card>
</template>

<script>

    import ProductsApi from '@/api/products';
    import DomainDataApi from '@/api/domaindata';
    import _find from 'lodash/find';

    export default {
        name: "ProductsList",
        data () {
            return {
                products: [],
                loading: true,
                pagination: {
                    rowsPerPage: 25
                },
                selected: [],
                headers: [
                    { text: 'Descrizione', align: 'left', value: 'Description' },
                    { text: 'Tipo Codice', align: 'left', value: 'TypeCode' },
                    { text: 'Articolo', align: 'left', value: 'ArticleCode' },
                    { text: 'Unità di Misura', align: 'left', value: 'UnitOfMeasure'},
                    { text: 'IVA', align: 'left', value: 'VatTypeId'},
                    { text: 'Prezzo Unitario', align: 'right', value: 'UnitPrice'},
                    { text: '', align: 'center', value: 'Id', sortable: false }
                ],
                search: '',
                itemToDelete: {},
                deleteDialog: false,
                vatTypes: [],
            }
        },
        mounted () {
            this.getDataFromApi();
        },
        methods: {
            getDataFromApi () {
                this.loading = true;

                DomainDataApi.getVatList()
                    .then(t => {
                        this.vatTypes = t.data;
                    });

                ProductsApi.getProducts()
                    .then(t => {
                        this.products = t.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            },
            createProduct() {
                ProductsApi.newProduct()
                    .then(t => {
                        this.$router.push({name:'product', params: { id: t.data.Id }});
                    })
                    .catch(() => {
                        this.$root.showBottomError('Errore, contattare l\'assistenza',true);
                    })
            },
            editItem(item) {
                this.$router.push({name:'product', params: { id: item.Id }});
            },
            showDeleteItemDialog(item) {
                this.itemToDelete = item;
                this.deleteDialog = true;
            },
            deleteItem(item) {
                ProductsApi.deleteProduct(item.Id)
                    .then(() => {
                        this.products.splice(this.products.indexOf(item), 1);
                        this.$root.showBottomMessage('Prodotto cancellato',false);
                    })
                    .finally(() => {
                        this.itemToDelete = {};
                        this.deleteDialog = false;
                    });
            },
            decodeVatType(vatTypeId) {
                let vt = _find(this.vatTypes, {Id:vatTypeId});
                if (vt) {
                    return vt.Description;
                } else {
                    return '';
                }
            },
            duplicate(item) {
                ProductsApi.duplicateProduct(item.Id)
                    .then(t => {
                        this.$root.showBottomMessage('Prodotto duplicato correttamente', false);
                        setTimeout(function(that, resp){
                            that.$router.push({name:'product', params: { id: resp.data.Id }});
                        }(this, t), 2000);
                    })
                    .catch(t => {
                        let msg = t.response.data;
                        if (msg) {
                            this.$root.showBottomError(msg, true);
                        } else {
                            this.$root.showBottomError('Errore nel salvataggio, verifica i dati o contatta l\'assistenza', true);
                        }
                    })

            },
        }
    }
</script>

<style scoped>
</style>